import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject, filter, takeUntil } from 'rxjs';
import { SessionService } from 'src/app/shared/services';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false,
})
export class HeaderDHLComponent implements OnInit, OnDestroy {
    public administrativeLoginURL: string;
    public homeURL: string;
    public showFacilityInformation: boolean;
    public cartDisallowedRoutes: string[];
    public loginDisallowedRoutes: string[];
    private unsubscribe$: Subject<void> = new Subject();
    public displayDhlAviationLogo: boolean = false;

    constructor(
        private sessionService: SessionService,
        private changeDetectorRef: ChangeDetectorRef,
        private router: Router
    ) {
        this.homeURL = 'search-awb';
        this.administrativeLoginURL = '';
        this.showFacilityInformation = true;
        this.cartDisallowedRoutes = ['cart/confirmation'];
    }

    ngOnInit(): void {
        this.subscribeToAuthenticatedUserRoutes();
        this.checkSearchAwbRoute();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    subscribeToAuthenticatedUserRoutes(): void {
        this.sessionService
            .isAuthenticated$()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (isAuthenticated) => {
                    this.loginDisallowedRoutes = !isAuthenticated ? ['search-awb'] : [];
                    this.changeDetectorRef.detectChanges();
                },
            });
    }

    checkSearchAwbRoute(): void {
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                takeUntil(this.unsubscribe$)
            )
            .subscribe(() => {
                this.displayDhlAviationLogo = !this.router.url.endsWith('search-awb');
            });
    }
}
